"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBreadcrumb = exports.BmBreadcrumb = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _bmBreadcrumbItem = require("./bm-breadcrumb-item");

var _bmIcon = require("./bm-icon");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["<bm-icon type=", " />"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<li>\n\t\t\t\t", "\n\t\t\t\t<bm-breadcrumb-item\n\t\t\t\t\t.label=\"", "\"\n\t\t\t\t\t.url=\"", "\"\n\t\t\t\t\t.icon=\"", "\"\n\t\t\t\t\t.disabled=\"", "\"\n\t\t\t\t\t@item-click=\"", "\">\n\t\t\t\t</bm-breadcrumb-item>\n\t\t\t</li>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t<ol>\n\t\t\t", "\n\t\t</ol>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host ol li {\n\t\tlist-style-type: none;\n\t\tmargin: 10px 10px 0 0;\n\t}\n\t:host ol li bm-icon {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t\tvertical-align: middle;\n\t}\n\t:host([type='horizontal']) ol li {\n\t\tdisplay: inline;\n\t}\n\t:host([type='vertical']) ol :nth-child(2) {\n\t\tpadding-left: 10px;\n\t}\n\t:host([type='vertical']) ol :nth-child(3) {\n\t\tpadding-left: 20px;\n\t}\n\t:host([type='vertical']) ol :nth-child(4) {\n\t\tpadding-left: 30px;\n\t}\n\t:host([type='vertical']) ol :nth-child(5) {\n\t\tpadding-left: 40px;\n\t}\n\t:host([type='vertical']) ol :nth-child(6) {\n\t\tpadding-left: 50px;\n\t}\n\t:host([type='vertical']) ol :nth-child(7) {\n\t\tpadding-left: 60px;\n\t}\n\t:host([type='vertical']) ol :nth-child(8) {\n\t\tpadding-left: 70px;\n\t}\n\t:host([type='vertical']) ol :nth-child(9) {\n\t\tpadding-left: 80px;\n\t}\n\t:host([type='vertical']) ol :nth-child(10) {\n\t\tpadding-left: 90px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmBreadcrumb = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmBreadcrumb, _BlueElement);

  var _super = (0, _createSuper2.default)(BmBreadcrumb);

  (0, _createClass2.default)(BmBreadcrumb, null, [{
    key: "is",
    get: function get() {
      return 'bm-breadcrumb';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        type: {
          type: String,
          attribute: true,
          reflect: true
        },
        disableLinks: {
          type: Boolean,
          attribute: false,
          reflect: false
        },
        separatorIcon: {
          type: String,
          attribute: false,
          reflect: false
        },
        items: {
          type: Array,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmBreadcrumb() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmBreadcrumb);
    _this = _super.call(this);
    _this.type = '';
    _this.disableLinks = false;
    _this.separatorIcon = void 0;
    _this.items = [];
    _this.onItemSelect = (0, _bind.default)(_context = _this.onItemSelect).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmBreadcrumb, [{
    key: "onItemSelect",
    value: function onItemSelect(event) {
      this.dispatchEvent(new CustomEvent('item-select', {
        detail: {
          current: event.detail,
          items: this.items
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.html(_templateObject2(), (0, _element.guard)(this.items, function () {
        return _this2.renderItems(_this2.items);
      }));
    }
  }, {
    key: "renderItems",
    value: function renderItems(items) {
      var _this3 = this;

      return (0, _repeatInstanceProperty(_element))(items, function (i) {
        return i.label;
      }, function (item, index) {
        return _this3.html(_templateObject3(), (0, _element.guard)(_this3.separatorIcon, function () {
          return _this3.renderSeparatorIcon();
        }), item.label, item.url, item.icon, _this3.disableLinks || item.disabled || index === items.length - 1, _this3.onItemSelect);
      });
    }
  }, {
    key: "renderSeparatorIcon",
    value: function renderSeparatorIcon() {
      if (this.separatorIcon) {
        return this.html(_templateObject4(), this.separatorIcon);
      }

      return _element.nothing;
    }
  }]);
  return BmBreadcrumb;
}(_element.BlueElement);

exports.BmBreadcrumb = BmBreadcrumb;

var registerBreadcrumb = function registerBreadcrumb() {
  (0, _bmBreadcrumbItem.registerBreadcrumbItem)();
  (0, _bmIcon.registerIcon)();
  (0, _element.register)(BmBreadcrumb);
};

exports.registerBreadcrumb = registerBreadcrumb;
